import { api, fetchData, postData } from './api';
import { PATH_SEGMENTS } from '../config/paths';

export type PostCallJobStatus =
  | 'queued'
  | 'running'
  | 'succeeded'
  | 'partial'
  | 'failed';

export type PostCallStepStatus =
  | 'pending'
  | 'running'
  | 'succeeded'
  | 'failed'
  | 'skipped';

export interface PostCallStep {
  id: number;
  analysis_type: 'mmt' | 'eval' | 'summary' | 'adherence' | 'kpi';
  status: PostCallStepStatus;
  tae_id: number | null;
  started_at: string | null;
  finished_at: string | null;
  error_message: string | null;
}

export interface PostCallJob {
  id: number;
  interaction_id: number;
  transcript_id: number;
  status: PostCallJobStatus;
  trigger_source: string;
  created_at: string;
  started_at: string | null;
  finished_at: string | null;
  error_message: string | null;
  steps: PostCallStep[];
}

export async function getPostCallStatus(interactionId: number): Promise<PostCallJob | null> {
  const response = await fetchData<{ interaction_id: number; job: PostCallJob | null }>(
    api(PATH_SEGMENTS.INTERACTION, interactionId, 'post-call', 'status')
  );
  return response.job;
}

export async function getPostCallStatuses(
  interactionIds: number[]
): Promise<Record<number, PostCallJob>> {
  if (interactionIds.length === 0) return {};
  const params = new URLSearchParams();
  interactionIds.forEach(id => params.append('interaction_ids', String(id)));
  const response = await fetchData<{ jobs: Record<string, PostCallJob> }>(
    `${api('post-call', 'status')}?${params.toString()}`
  );
  return Object.fromEntries(
    Object.entries(response.jobs || {}).map(([key, value]) => [Number(key), value])
  );
}

export async function runPostCall(
  interactionId: number,
  force = false
): Promise<{ job_id: number; created: boolean; status: PostCallJob | null }> {
  return postData(
    `${api(PATH_SEGMENTS.INTERACTION, interactionId, 'post-call', 'run')}?force=${force}`,
    {}
  );
}
